export const url = {
  pro: "https://larosebackend.kwintechnologies.com/api/",
  dev: "http://47.130.2.255:5000/api/",
  local: "http://192.168.100.64:7071/api/",
};

export const API_URL = (field = "pro") => url[field];
